module.exports = __webpack_public_path__ + "img/clock-icon.a233bd28.svg";